<template>
  <div class="jps-search-pagesize">
    <div
      v-if="manual"
      class="field has-addons"
      :aria-label="lss('表示件数', 'number of list')"
    >
      <div>
        <input class="input" type="number" v-model="size" />
      </div>
      <div>
        <button class="button is-info" @click="go()">
          {{ lss('反映', 'Apply') }}
        </button>
      </div>
    </div>
    <div v-else>
      <BaseSelect
        class="jps-round-select jps-small"
        :options="values"
        :label-function="v => lst({ ja: '{}件', en: '{}' }, v)"
        v-model="size"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { lst, lss } = useI18n()

interface Props {
  manual?: boolean
  ss: SearchStore<any>
  values?: number[]
}
const props = withDefaults(defineProps<Props>(), {
  manual: false,
  values: () => [20, 50, 100],
})

const innnerSize = ref(0)

const size = computed({
  get: () => {
    return props.ss.state.size
  },
  set: s => {
    if (props.manual) {
      innnerSize.value = s
    } else {
      props.ss.setSize(s)
    }
  },
})

const go = () => {
  props.ss.setSize(innnerSize.value)
}
</script>

<style lang="scss">
.jps {
  .jps-search-pagesize {
    .jps-round-select {
      select {
        font-size: 0.875rem !important;
      }
    }
  }
}
</style>
